import { getUnits, saveUnits } from "util/LocalDataManager";
import {
    FETCH_ERROR,
    FETCH_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    ERROR_OTHERS,

    FETCH_USER_UNITS_START,
    UNITS_DATA
} from "../../constants/ActionsTypes";
import axios from 'util/Api';

export const fetchUserUnits = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_USER_UNITS_START });
        axios.get('/getunitsforuser', {
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    dispatch({ type: FETCH_SUCCESS });
                    saveUnits(data.result.units); // Save units to local storage
                    dispatch({ type: UNITS_DATA, payload: data.result.units });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    const localUnits = getUnits(); // Fallback to local data
                    if (localUnits.length > 0) {
                        dispatch({ type: UNITS_DATA, payload: localUnits });
                        dispatch({ type: FETCH_SUCCESS });
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};
